import { CompetitionMatchEvent } from './competition-match-event'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionMatchEventSerializer {
  fromJson(json: any): CompetitionMatchEvent {
    const competitionMatchEvent = {
      ...json
    }

    return competitionMatchEvent
  }

  toJson(competitionMatchEvent: CompetitionMatchEvent): any {
    return {
      ...competitionMatchEvent
    }
  }
}
